module.exports = __webpack_public_path__ + "static/img/logo barroc.cda0af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/logo barroc.png
// module id = tG61
// module chunks = 0